import React, { useMemo } from 'react';

import { Spinner } from '~components';
import Icon, { faCheck, faMinus, faXmark } from '~components/icon';

interface ComponentProps {
  id: string;
  row: any;
  isValidating?: boolean;
}

const ClaimValidIcon: React.FC<ComponentProps> = ({ id, row, isValidating }) => {
  const hasErrors = row.alert_items?.length > 0;

  const indicator = useMemo(() => {
    if (isValidating) {
      return <Spinner type="clip" loading size={14} />;
    }
    if (hasErrors) {
      return <Icon icon={faXmark} color="red" />;
    }
    if (row.is_ignored) {
      return <Icon icon={faMinus} />;
    }
    return <Icon icon={faCheck} color="green" />;
  }, [isValidating, hasErrors, row.is_ignored]);

  return (
    <>
      <div className="d-flex justify-content-center" id={`claim-valid-icon-${id}`}>
        {indicator}
      </div>
    </>
  );
};

export default ClaimValidIcon;
